import styled from "styled-components";

export const FilterLabel = styled.label`
display: flex;
flex-direction: column;
gap: 4px;
max-width: 160px;
margin-bottom: 8px;
`